import { ThemeService } from './theme';
import type { LocalStore } from 'zf-web-infra';

class Meta {

  private server: ThemeService | undefined;

  init(local: LocalStore): void {
    this.server = new ThemeService(local);
    this.setFavicon(this.server.getFavicon());
    this.setTitle(this.server.getAppName());

    this.setMeta('theme-color', this.server.getPrimaryColor());
    this.setMeta('description', this.server.getAppDescription());
    this.setMeta('keywords', this.server.getAppKeyword());

    this.setMeta('og:title', this.server.getAppName());
    this.setMeta('og:description', this.server.getAppDescription());
    this.setMeta('og:image', this.server.getLogo());
  }

  private setMeta(name: string, content: string): void {
    const meta = document.querySelector(`meta[name="${name}"]`);
    if (meta != null) {
      return meta.setAttribute('content', content);
    }
    const element = document.createElement('meta');
    element.name = name;
    element.content = content;
    document.head.appendChild(element);
  }

  private setTitle(title: string): void {
    if (document.title !== title) {
      document.title = title;
    }
    const element = document.createElement('title');
    element.innerText = title;
    document.head.appendChild(element);
  }

  private setFavicon(favicon: string): void {
    const icon = document.querySelector('link[rel="icon"]');
    if (icon != null) {
      return icon.setAttribute('href', favicon);
    }

    const link = document.createElement('link');
    link.rel = 'icon';
    link.type = 'image/x-icon';
    link.href = favicon;
    document.head.appendChild(link);
  }

}

export const meta = new Meta();
